import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getApiBase } from "../config";

const API_BASE_URL = getApiBase(); // Use the helper function
const Dashboard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  // 1. Fetch Real Data from AWS Backend
  useEffect(() => {
    const fetchMyStats = async () => {
      try {
        const token = localStorage.getItem("access_token");
        if (!token) {
          navigate("/login");
          return;
        }

        const response = await fetch(`${API_BASE_URL}/org/my-stats`, {
          headers: {
            Authorization: `Bearer ${token}`, // Send the token!
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();
          setStats(data);
        } else {
          console.error("Failed to load stats");
          if (response.status === 401) navigate("/login");
        }
      } catch (error) {
        console.error("Network error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMyStats();
  }, [navigate]);

  if (loading)
    return (
      <div className="p-8 text-white">Loading your secure dashboard...</div>
    );

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 p-8 font-sans">
      <div className="max-w-7xl mx-auto">
        {/* HEADER */}
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-slate-900 dark:text-white">
              {stats?.company_name || "My Organization"}
            </h1>
            <p className="text-slate-500 dark:text-slate-400">
              Client Dashboard
            </p>
          </div>
        </div>

        {/* STATS CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {/* TOKEN BALANCE */}
          <div className="bg-white dark:bg-slate-800 p-6 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700">
            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
              Token Balance
            </p>
            <h3 className="text-4xl font-bold text-blue-600 mt-2">
              {stats?.token_balance ?? "..."}
            </h3>
            <p className="text-xs text-slate-400 mt-2">Available for use</p>
          </div>

          {/* FILES PROCESSED */}
          <div className="bg-white dark:bg-slate-800 p-6 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700">
            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
              Total Files Processed
            </p>
            <h3 className="text-4xl font-bold text-slate-900 dark:text-white mt-2">
              {stats?.total_files_processed ?? 0}
            </h3>
          </div>

          {/* ACCOUNT STATUS */}
          <div className="bg-white dark:bg-slate-800 p-6 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700">
            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
              Account Status
            </p>
            <div className="mt-2">
              <span
                className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                  stats?.status === "Active"
                    ? "bg-green-100 text-green-800"
                    : "bg-red-100 text-red-800"
                }`}
              >
                {stats?.status || "Unknown"}
              </span>
            </div>
          </div>
        </div>

        {/* EDGE WORKER DOWNLOAD */}
        <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 p-6 mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-lg font-medium text-slate-900 dark:text-white">
                iRedact Edge Worker
              </h3>
              <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
                Download and install the edge worker to process documents locally.
              </p>
            </div>
            <a
              href="/iRedactEdgeWorker-Setup-1.0.22.exe"
              download
              className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              Download
            </a>
          </div>
        </div>

        {/* EMPTY STATE / RECENT ACTIVITY PLACEHOLDER */}
        <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 p-12 text-center">
          <h3 className="text-lg font-medium text-slate-900 dark:text-white">
            No Recent Redactions
          </h3>
          <p className="text-slate-500 mt-2">
            Upload a document to start using the brain.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
